import { EntityType } from '@miq/domain';
import { isAExternalAvailabilityReviewer } from '@shared/resolvers/user-info.resolver';

export enum ViewTypes {
  Table = 'table',
  Map = 'map',
  ChMap = 'chMap',
  GroupTable = 'grouptable',
  Id = 'id',
  Associate = 'associate',
  SplitReview = 'splitreview',
  CCRAASplitReview = 'ccrasplitreview',
  // View to exclude filters if they are configured on the Catalog
  // This is so far implemented for Company - Hierarchy Filter
  ExcludeEnable = 'excludeEnable',
}
export type SearchView =
  | ViewTypes.Table
  | ViewTypes.Id
  | ViewTypes.GroupTable
  | ViewTypes.Associate
  | ViewTypes.SplitReview
  | ViewTypes.CCRAASplitReview
  | ViewTypes.ExcludeEnable;

export type AllViews = 'map' | 'chMap' | SearchView;

export const SEARCH_VIEW_BY_ENTITY_MAPPING = {
  [EntityType.Company]: ViewTypes.ExcludeEnable,
};

export const getSearchViewByGroupAndEntity = (entity: EntityType) => {
  if (entity === EntityType.Availability) {
    return isAExternalAvailabilityReviewer() ? ViewTypes.ExcludeEnable : null;
  }

  return SEARCH_VIEW_BY_ENTITY_MAPPING[entity];
};
